import { z } from 'zod';

export const ThemeName = z.enum(['main', 'invert']);
export type ThemeName = z.infer<typeof ThemeName>;
